// Peso atual. O `RulerPicker` é o de sempre — só a moldura mudou.
// O payload continua `CURRENT_WEIGHT` como string "80,0".

import React, { useEffect, useState } from "react";

import RulerPicker from "../components/RulerPicker.jsx";
import { CardRegua } from "../widgets/Widgets.jsx";

const StepCurrentWeight = ({ setCanProceed, setStepData }) => {
  const [valor, setValor] = useState(75.0);

  useEffect(() => {
    setCanProceed(true);
    setStepData({ CURRENT_WEIGHT: valor.toFixed(1).replace(".", ",") });
  }, [valor, setCanProceed, setStepData]);

  return (
    <CardRegua valor={valor.toFixed(1).replace(".", ",")} unidade="kg">
      <RulerPicker
        axis="x"
        min={40}
        max={150}
        step={0.2}
        decimals={1}
        majorEvery={1}
        initialValue={75.0}
        onChange={setValor}
      />
    </CardRegua>
  );
};

export default StepCurrentWeight;
